import { styled, Typography, TypographyTypeMap } from "@mui/material";
import { OverridableComponent } from "@mui/material/OverridableComponent";

export const PopularPackagesHeader = styled(Typography)`
  font-weight: 500;
  font-size: 24px;
  line-height: 34px;
  letter-spacing: 0.1px;
` as OverridableComponent<TypographyTypeMap<Record<string, unknown>, "span">>;
